// extracted by mini-css-extract-plugin
module.exports =  {"SpecSettingModal":"SpecSettingModal__BnJJJ"};